import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const Price = ({ amount, currency }) => {
  const { formatNumber } = useIntl();
  return formatNumber(amount, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

Price.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string.isRequired,
};

export default Price;
